export const TOGGLE_TE_STATUS = 'TOGGLE_TE_STATUS';
export const SET_TE_STORAGE_KEY = 'SET_TE_STORAGE_KEY';
export const SAVE_EDITS_SUCCESS = 'SAVE_EDITS_SUCCESS';
export const SAVE_EDITS_FAILURE = 'SAVE_EDITS_FAILURE';
export const SET_ED_DISABLED_COLUMNS = 'SET_ED_DISABLED_COLUMNS';
export const SET_IS_TE_EDITABLE = 'SET_IS_TE_EDITABLE';